// Fumadocs UI の日本語の文言。公開 docs と admin の社内 docs で使う。
// キーは fumadocs-ui の英語の原文で、括弧の中はその文言が出る場所（fumadocs-ui/dist/.translations/keys.js）。
export const fumadocsJa = {
  displayName: "日本語",
  "Search(search trigger)": "ドキュメントを検索",
  "Search(search dialog)": "ドキュメントを検索",
  "Open Search(search trigger)(aria-label)": "検索を開く",
  "Close Search(search dialog)(aria-label)": "検索を閉じる",
  "No results found(search dialog)": "結果が見つかりません",
  "On this page(table of contents)": "このページの内容",
  "Table of Contents(inline table of contents)": "目次",
  "No Headings(table of contents)": "見出しはありません",
  "Last updated on(page footer)": "最終更新日",
  "Next Page(pagination)": "次のページ",
  "Previous Page(pagination)": "前のページ",
  "Choose a language(language switcher)": "言語を切り替える",
  "Choose a language(language switcher)(aria-label)": "言語を切り替える",
  "Toggle Theme(theme switcher)(aria-label)": "テーマを切り替える",
  "Light(theme switcher)(aria-label)": "ライト",
  "Dark(theme switcher)(aria-label)": "ダーク",
  "System(theme switcher)(aria-label)": "システム",
  "Open Sidebar(sidebar)(aria-label)": "サイドバーを開く",
  "Close Sidebar(sidebar)(aria-label)": "サイドバーを閉じる",
  "Collapse Sidebar(sidebar)(aria-label)": "サイドバーを閉じる",
  "Toggle Menu(mobile menu)(aria-label)": "メニューを開閉",
  "Copy Text(code block)(aria-label)": "コピー",
  "Copied Text(code block)(aria-label)": "コピーしました",
  "Copy Anchor Link(heading anchor)(aria-label)": "見出しへのリンクをコピー",
  "Copied Anchor Link(heading anchor)(aria-label)": "リンクをコピーしました",
  "Copy Link(accordion)(aria-label)": "リンクをコピー",
  "Copied Link(accordion)(aria-label)": "リンクをコピーしました",
};
